import { UserNotification, UserNotificationUtilService } from "@scisys-uim/uim-common";

export class FirearmAssignmentNotificationService implements UserNotificationUtilService {

    unableToDismissReason(notification?: UserNotification): string {
      return ""
    }
  
    canBeDismissed(notification: UserNotification): boolean {
      return true;
    }
  
    getUserMessageType(): string {
      return "FirearmAssignmentAction";
    }
  
    getRouteFromLinkData(notification: UserNotification): any[] {
      return ['/firearms'];
    }
  
  getRouteLinkQueryParams(notification: UserNotification) {
    return {
      pendingAssignmentAssetId: notification.linkData.pendingAssignmentAssetId
    };
  }
  
  }
